import React from 'react';

const BlogsSkeleton = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {[1, 2, 3, 4, 5, 6].map((item) => (
        <div
          key={item}
          className="bg-white rounded-2xl shadow-lg overflow-hidden animate-pulse"
        >
          {/* Blog Image Skeleton */}
          <div className="relative h-48 overflow-hidden bg-gray-200">
            <div className="w-full h-full bg-gray-300"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-gray-300/50 to-transparent"></div>
          </div>

          {/* Blog Content Skeleton */}
          <div className="p-6">
            {/* Title Skeleton - Two lines for potential long titles */}
            <div className="space-y-2 mb-3">
              <div className="h-5 bg-gray-200 rounded w-4/5"></div>
              <div className="h-5 bg-gray-200 rounded w-3/5"></div>
            </div>

            {/* Description Skeleton - Three lines */}
            <div className="space-y-2 mb-6">
              <div className="h-3 bg-gray-200 rounded w-full"></div>
              <div className="h-3 bg-gray-200 rounded w-11/12"></div>
              <div className="h-3 bg-gray-200 rounded w-4/5"></div>
            </div>

            {/* Action Buttons Skeleton */}
            <div className="flex gap-2">
              {/* View Button - Icon only */}
              <div className="flex-1 bg-gray-200 py-2 rounded-lg flex items-center justify-center">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
              </div>

              {/* Edit Button */}
              <div className="bg-gray-200 text-gray-200 px-4 py-2 rounded-lg w-20">
                <div className="h-4 bg-gray-300 rounded w-full"></div>
              </div>

              {/* Delete Button */}
              <div className="bg-gray-200 text-gray-200 px-4 py-2 rounded-lg w-20 flex items-center justify-center">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlogsSkeleton;